<script setup>
import { computed, onMounted, ref } from "vue"

import Lottie from "@/components/widgets/lottie.vue"
import animationData from "@/components/widgets/msoeawqm.json"
import * as persianTools from "@persian-tools/persian-tools"
import PersianDate from "persian-date"

import store from "../../state/store"
import useCooperationRequests from "../../use/useCooperationRequests"
import useDebouncedFunction from "../../use/useDebouncedFunction"

const cooperationRequests = computed(() => store.state.cooperationRequests)

const { search, perPage, getCooperationRequests } = useCooperationRequests()
const { handleInput } = useDebouncedFunction(getCooperationRequests)

onMounted(() => {
  getCooperationRequests()
})

const toPersianDateTime = (date) => {
  const [datePart] = date.split(" ")
  const [year, month, day] = datePart.split("-")
  const gregorianDate = new Date(year, month - 1, day)
  const persianDate = new PersianDate(gregorianDate)
  return persianDate.format("YYYY/MM/DD")
}

function getForPage(ev, link) {
  ev.preventDefault()
  if (!link.url || link.active) {
    return
  }

  getCooperationRequests(link.url)
}

const defaultOptions = ref({
  animationData: animationData,
})
</script>

<template>
  <b-card-body class="border-bottom-dashed border-bottom">
    <b-row class="g-3">
      <b-col xl="10">
        <div class="search-box">
          <input
            v-model="search"
            @input="handleInput"
            type="text"
            class="form-control search"
            placeholder="جستجوی نام، شماره تماس و ..."
          />
          <i class="ri-search-line search-icon"></i>
        </div>
      </b-col>

      <b-col xl="2">
        <b-row class="g-3">
          <b-col sm="12">
            <select
              @change="getCooperationRequests(null)"
              v-model="perPage"
              class="form-select mb-3"
              aria-label="Default select example"
            >
              <option value="" selected>نمایش تعداد ردیف</option>
              <option value="5">5</option>
              <option value="10">10</option>
              <option value="20">20</option>
              <option value="30">30</option>
              <option value="50">50</option>
            </select>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
  </b-card-body>
  <b-card-body>
    <div>
      <div class="table-responsive table-card mb-1">
        <table class="table align-middle" id="cooperationRequestTable">
          <thead class="table-light text-muted">
            <tr>
              <th class="sort" data-sort="fullname">نام</th>
              <th class="sort" data-sort="phone">تلفن</th>
              <th class="sort" data-sort="date">تاریخ ثبت</th>
              <th class="sort" data-sort="description">توضیحات</th>
            </tr>
          </thead>
          <tbody
            class="list"
            v-if="
              cooperationRequests.loading || !cooperationRequests.data.length
            "
          >
            <tr>
              <td colspan="8">
                <div class="text-center">
                  <b-spinner
                    v-if="cooperationRequests.loading"
                    variant="dark"
                    style="width: 3rem; height: 3rem"
                  ></b-spinner>
                  <div v-else>
                    <lottie
                      class="avatar-xl"
                      colors="primary:#121331,secondary:#08a88a"
                      :options="defaultOptions"
                      :height="75"
                      :width="75"
                    />
                    <h5 class="mt-2">هیچ درخواست همکاری وجود ندارد!</h5>
                  </div>
                </div>
              </td>
            </tr>
          </tbody>

          <tbody class="list" v-else>
            <tr v-for="(item, index) of cooperationRequests.data" :key="index">
              <td class="fullname">{{ item.full_name }}</td>
              <td class="phone">
                {{ persianTools.digitsEnToFa(item.phone_number) }}
              </td>
              <td class="date">{{ toPersianDateTime(item.created_at) }}</td>
              <td class="description">{{ item.description }}</td>
            </tr>
          </tbody>
        </table>
      </div>

      <div
        class="d-flex justify-content-end"
        v-if="cooperationRequests.total > cooperationRequests.limit"
      >
        <div class="pagination-wrap hstack gap-2" style="display: flex">
          <ul class="pagination listjs-pagination mb-0">
            <li
              v-for="(link, i) of cooperationRequests.links"
              :key="i"
              class="page-item"
              :class="{
                disabled: !link.url,
                active: link.active || !link.url,
              }"
            >
              <span
                class="page-link"
                v-if="link.active"
                v-html="link.label"
              ></span>

              <a
                v-else
                href="#"
                @click="getForPage($event, link)"
                class="page-link"
                v-html="link.label"
              >
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </b-card-body>
</template>

<style scoped>
.phone {
  direction: ltr !important;
}
</style>
